// Firebase Configuration
import { initializeApp, getApps, getApp, FirebaseApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";
import { getAnalytics, isSupported as analyticsSupported, Analytics } from "firebase/analytics";
import { getMessaging, Messaging } from "firebase/messaging";

// Your web app's Firebase configuration (v7.20.0+; measurementId optional)

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyCVZy9etMQWG__UBtgxTnGOIZ28buCDn14",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "cue-live-50585.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "cue-live-50585",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "cue-live-50585.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "132372805332",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:132372805332:web:d59d58a6170c645602ed41",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-TYJSCMDT7E"
};

// Debug: Log Firebase config (remove sensitive data in production)
if (typeof window !== 'undefined' && import.meta.env.DEV) {
  console.log('[Firebase Config]', {
    apiKey: firebaseConfig.apiKey ? `${firebaseConfig.apiKey.substring(0, 10)}...` : 'MISSING',
    authDomain: firebaseConfig.authDomain,
    projectId: firebaseConfig.projectId,
    appId: firebaseConfig.appId,
    envVarsLoaded: {
      apiKey: !!import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: !!import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: !!import.meta.env.VITE_FIREBASE_PROJECT_ID,
    }
  });
}



// Initialize Firebase (single app instance)
export const app: FirebaseApp =
  getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);

// Analytics (optional) – init in browser when supported
export let analytics: Analytics | null = null;
if (typeof window !== "undefined") {
  analyticsSupported()
    .then((ok) => {
      if (ok) analytics = getAnalytics(app);
    })
    .catch(() => {});
}

// Messaging (required for Web Push / FCM chat notifications)
// Initialised synchronously so it is ready before the first getToken() call.
// Unsupported environments surface errors at getToken() time, handled in push.ts.
export let messaging: Messaging | null = null;
if (typeof window !== "undefined") {
  try {
    messaging = getMessaging(app);
  } catch {
    // Push / SW not supported in this browser context (non-HTTPS, no SW support, etc.)
  }
}

export default app;
